import React from "react";
import { FaGift, FaExclamationTriangle, FaCheckCircle } from "react-icons/fa";
import { daysUntilLabel } from "../utils/dashboardAgentAlertUtils";

function AlertCard({
  title,
  count,
  emptyText,
  items,
  loading,
  accentClass,
  iconWrapClass,
  Icon,
}) {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-100 border-t-4 ${accentClass} p-3 min-h-0`}
    >
      <div className="flex items-start gap-2">
        <div
          className={`w-7 h-7 rounded-md ${iconWrapClass} text-white flex items-center justify-center flex-shrink-0`}
        >
          <Icon className="text-xs" />
        </div>
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-blue-900 leading-tight">
            {title}
          </h3>
          <p className="text-xs text-gray-500">{count} agent(s)</p>
        </div>
      </div>
      <div className="border-t border-gray-100 mt-2 pt-2">
        {loading ? (
          <p className="text-xs text-gray-400 text-center py-1">…</p>
        ) : items.length === 0 ? (
          <p className="text-xs text-gray-400 text-center py-1 flex items-center justify-center gap-1.5">
            <FaCheckCircle className="text-green-500" />
            {emptyText}
          </p>
        ) : (
          <ul className="space-y-1 max-h-28 overflow-y-auto">
            {items.map((item) => (
              <li key={item.id} className="text-xs text-gray-700">
                <span className="font-medium">{item.name}</span>
                <span className="text-gray-500">
                  {" "}
                  · {item.dateLabel} ({daysUntilLabel(item.days)})
                </span>
                {item.licenseType ? (
                  <span className="block text-[11px] text-gray-400">
                    {item.licenseType}
                  </span>
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

const DashboardAgentAlerts = ({ birthdays, expiries, loading }) => {
  return (
    <div className="xl:w-72 flex flex-col gap-3 flex-shrink-0">
      <AlertCard
        title="Birthdays This Week"
        count={birthdays.length}
        emptyText="No birthdays this week"
        items={birthdays}
        loading={loading}
        accentClass="border-t-green-500"
        iconWrapClass="bg-green-500"
        Icon={FaGift}
      />
      <AlertCard
        title="RECO License Expiring"
        count={expiries.length}
        emptyText="No expiries coming up"
        items={expiries}
        loading={loading}
        accentClass="border-t-orange-500"
        iconWrapClass="bg-orange-500"
        Icon={FaExclamationTriangle}
      />
    </div>
  );
};

export default DashboardAgentAlerts;
